module.exports = __webpack_public_path__ + "static/media/ic-close.1e9404e2.svg";